
// Air Liquide PROD
export const environment = {
  clientName: 'airliquide',
  production: true,
  firebase: {
    apiKey: 'AIzaSyBgmsNoIn9gfgfsJ1prWCW165fkFhwubGs',
    authDomain: 'dianet-air-liquide.firebaseapp.com',
    databaseURL: 'https://dianet-air-liquide.firebaseio.com',
    projectId: 'dianet-air-liquide',
    storageBucket: 'dianet-air-liquide.appspot.com',
    messagingSenderId: '332582450986'
  },
  paymentGateway: {
    // PROD
    entityId: '8acda4c76bdb30c9016be67c304e5431',
    bearerAuthToken: 'OGFjN2E0Yzk2YzA5YzY4YzAxNmMwYWNkNjAwMTAxZDZ8ajhSVDRBWVd6eQ==',
    hostUrl: 'https://oppwa.com/'
  },
  hostingUrl: 'https://dianet-air-liquide.firebaseapp.com',
  functionsUrl: 'https://us-central1-dianet-air-liquide.cloudfunctions.net'
};
